module.exports = __webpack_public_path__ + "media/BNP_Samodzielniak_26_F_2.4267dd4a.mp3";